import memoize from 'lodash/memoize';

import { fg } from '@atlaskit/platform-feature-flags';

import { getSAINHelloLayerFrontendExperiment } from './get-sain-layer-frontend-experiment';

const isLuminaEnabledUnmemoized = () => {
	if (fg('kd_dynamic_layout_in_sain')) {
		return true;
	}

	// Do not file exposure. We use backend event to track exposure instead.
	const { serveExperiment } = getSAINHelloLayerFrontendExperiment({
		abTestId: 'kd_lumina_in_sain',
	});

	return serveExperiment;
};

export const SAINFeatureControl = {
	isLuminaEnabled: memoize(isLuminaEnabledUnmemoized),
};
